module.exports = __webpack_public_path__ + "static/media/jds.ccdd975a.jpg";